/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSingleQuoteCommand } from './CreateSingleQuoteCommand';
import {
    CreateSingleQuoteCommandFromJSON,
    CreateSingleQuoteCommandFromJSONTyped,
    CreateSingleQuoteCommandToJSON,
    CreateSingleQuoteCommandToJSONTyped,
} from './CreateSingleQuoteCommand';

/**
 * 
 * @export
 * @interface CreateQuoteCommandDto
 */
export interface CreateQuoteCommandDto {
    /**
     * List of insurance quotes to create
     * @type {Array<CreateSingleQuoteCommand>}
     * @memberof CreateQuoteCommandDto
     */
    quotes: Array<CreateSingleQuoteCommand>;
}

/**
 * Check if a given object implements the CreateQuoteCommandDto interface.
 */
export function instanceOfCreateQuoteCommandDto(value: object): value is CreateQuoteCommandDto {
    if (!('quotes' in value) || value['quotes'] === undefined) return false;
    return true;
}

export function CreateQuoteCommandDtoFromJSON(json: any): CreateQuoteCommandDto {
    return CreateQuoteCommandDtoFromJSONTyped(json, false);
}

export function CreateQuoteCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQuoteCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quotes': ((json['quotes'] as Array<any>).map(CreateSingleQuoteCommandFromJSON)),
    };
}

export function CreateQuoteCommandDtoToJSON(json: any): CreateQuoteCommandDto {
    return CreateQuoteCommandDtoToJSONTyped(json, false);
}

export function CreateQuoteCommandDtoToJSONTyped(value?: CreateQuoteCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quotes': ((value['quotes'] as Array<any>).map(CreateSingleQuoteCommandToJSON)),
    };
}

